import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';

import Styled from 'styled';

import BigButtonView from 'four-nets/ui/big-button/big-button-view';
import TitleView from 'four-nets/ui/title-view';
import { AuthOrigin } from 'four-nets/user/auth/auth-ga-events';
import { Tab } from 'four-nets/user/auth/login-dialog';

import defaultStyles from './activation-link-view.scss';
import { FormattedMessage } from 'react-intl';

@Styled(defaultStyles)
class ActivationLinkView extends React.PureComponent {
    static contextTypes = {
        showLogin: PropTypes.func,
    };

    openLogin = () => {
        this.context.showLogin(() => this.props.history.push('/'), Tab.Login, AuthOrigin.AcivationLink);
    };

    render() {
        const { styles } = this.props;
        return (
            <React.Fragment>
                <div className={styles.centered}>
                    <TitleView
                        title={
                            <h3 className={styles.heading}>
                                <FormattedMessage id='EMAIL_VERIFIED' />.
                            </h3>
                        }
                    />
                    <span className={styles.button}>
                        <BigButtonView label={<FormattedMessage id='LOGIN' />} onClick={this.openLogin} />
                    </span>
                </div>
            </React.Fragment>
        );
    }
}

export default withRouter(ActivationLinkView);
